import { IState } from '../../store';

export const selectIsOfferRedesign = (state: IState) => {
  const { isOfferPageRedesign } = state;

  return isOfferPageRedesign;
};
